<template>
  <RoleGate minLevel="supervisor" :showWhenDenied="true">
    <div class="settings-form">
      
      <div class="form-grid">
        <!-- Nome Analista -->
        <div class="form-group">
          <label>Analista Porto Seguro (Nome)</label>
          <div class="input-wrapper">
            <i class="bi bi-headset icon"></i>
            <input 
              v-if="companyData && companyData.portoSeguroAnalista" 
              type="text" 
              class="form-control"
              v-model="companyData.portoSeguroAnalista.name" 
              placeholder="Nome do Analista" 
              required 
            />
          </div>
        </div>

        <!-- Telefone Analista -->
        <div class="form-group">
          <label>Telefone de Contato</label>
          <div class="input-wrapper">
            <i class="bi bi-headset text-success icon"></i>
            <input 
              v-if="companyData && companyData.portoSeguroAnalista" 
              type="text" 
              class="form-control"
              v-model="companyData.portoSeguroAnalista.phoneNumber" 
              placeholder="(00) 00000-0000"
              required 
            />
          </div>
        </div>
      </div>
      
      <div class="form-actions mt-4">
        <BotaoSalvarComponent @click="postForm" />
      </div>
    </div>
  </RoleGate>
</template>

<script setup>
import axios from '@/axios.js';
import BotaoSalvarComponent from './ui/BotaoSalvar.vue';
import { showToast } from '@/eventBus.js';
import RoleGate from './RoleGate.vue';

const props = defineProps({
    companyData: { type: Object, required: true },
});

function postForm() {
    axios.put(`/api/company/edit`, props.companyData)
        .then(response => {
            showToast(response.data.message);
        }).catch(error => {
            showToast(error?.response?.data?.data || "Erro ao salvar os dados do analista.");
        });
};
</script>

<style scoped>
/* Copied standardized V2 form layouts */
.settings-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 600;
  color: #475569;
  font-size: 0.9rem;
}

.input-wrapper {
  display: flex;
  align-items: center;
  background-color: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 0.5rem 1rem;
  transition: all 0.2s ease;
}

.input-wrapper:focus-within {
  border-color: #DF523A;
  box-shadow: 0 0 0 3px rgba(223, 82, 58, 0.1);
  background-color: #FFFFFF;
}

.input-wrapper .icon {
  font-size: 1.15rem;
  color: #94A3B8;
  margin-right: 0.75rem;
}

.text-success { color: #10B981 !important; }

.form-control {
  flex: 1;
  background: transparent;
  border: none;
  color: #1E293B;
  font-size: 0.95rem;
  font-family: inherit;
  font-weight: 500;
  padding: 0.25rem 0;
  outline: none;
}

.form-control::placeholder {
  color: #CBD5E1;
  font-weight: 400;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 767.98px) {
  .form-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>